import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { login } from "../../services/Action/userAction";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
	TextInput,
	AppShell,
	Text,
	useMantineTheme,
	Image,
	Button,
	Group,
	Box,
	Container,
	PasswordInput,
	Loader,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import googleicon from "../../static/svg/google-icon.svg";
import imageIcon from "../../static/svg/ivistlogin.svg";
import Footr from "../../components/Footr";
import axios from "axios";
import * as Constants from "../../constant";
import {
	showSuccessNotification,
	showErrorNotification,
} from "../../utils/Notifications";
function Login() {
	let navigate = useNavigate();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		(async () => {
			try {
				await axios.get(`${Constants?.LOCAL_URL}/api/auth/verify`, {
					withCredentials: true,
				});
				navigate("/dashboard");
			} catch (error) {}
		})();
	}, []);
	const notify = () => toast.warning("error");
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const theme = useMantineTheme();
	const form = useForm({
		initialValues: {
			email: "",
			password: "",
		},

		validate: {
			email: (value) =>
				/^\S+@\S+$/.test(value) ? null : "Invalid email",
			password: (value) => (value.length < 8 ? "Max 8 char" : null),
		},
	});
	const siginFormHandler = form.onSubmit(async (data) => {
		setLoading(true);
		const log = dispatch(await login(data));
		setLoading(false);
		if (log?.status === 201) {
			navigator("/dashboard");
			showSuccessNotification("Login Successfuly");
		} else {
			showErrorNotification("Error");
		}
	});
	return (
		<AppShell
			styles={{
				main: {
					position: "relative",
					minHeight: "calc(100vh - 48px)",
					maxHeight: "auto",
					background:
						theme.colorScheme === "dark"
							? theme.colors.ivisit_dark[0]
							: theme.colors.gray[0],
				},
			}}
			footer={<Footr />}
		>
			<div
				style={{
					background: "#040F1F",
					margin: "auto",
				}}
			>
				<ToastContainer />
				<Container className="signupForm" size="xs" px="xs">
					<Group position="center" align="center">
						<Image src={imageIcon} width={270} pb={30} pt={50} />
					</Group>
					<Text
						align="center"
						color="white"
						size="xl"
						weight={1000}
						pb={20}
						style={{ fontFamily: "SFPro Display ", color: "white" }}
					>
						Log In
					</Text>
					<Box sx={{ maxWidth: 340 }} mx="auto">
						<form onSubmit={siginFormHandler}>
							<TextInput
								placeholder="your@email.com"
								mr={10}
								styles={{
									input: { backgroundColor: "#252E3D" },
									root: {
										width: "100%",
										color: "white",
									},
								}}
								{...form.getInputProps("email")}
							/>

							<div
								style={{
									position: "relative",
								}}
							>
								<PasswordInput
									className="logInpMargin"
									placeholder="password"
									{...form.getInputProps("password")}
									styles={{
										input: {
											backgroundColor: "#252E3D",
											position: "relative",
										},
										root: {
											width: "100%",
											color: "white",
										},
									}}
								/>
								<Link
									style={{
										position: "absolute",
										top: "25%",
										right: "9%",
										fontSize: "12px",
										color: "grey",
										textDecoration: "none",
									}}
									to="/ForgotPassword"
								>
									Forgot Password
								</Link>
							</div>
							<Group position="center" className="logInpMargin">
								<Button
									style={{ width: "340px" }}
									type="submit"
								>
									Log In
								</Button>
							</Group>
							<Group position="center" className="logInpMargin">
								<Button
									style={{ width: "340px", color: "white" }}
									variant="outline"
									onClick={notify}
								>
									<Image
										src={googleicon}
										width={12}
										px={20}
									/>{" "}
									Login with Google
								</Button>
							</Group>
							<Group position="center" className="logInpMargin">
								<Text align="center" color="rgb(173, 181, 189)">
									Are you a new Visitor?
								</Text>
							</Group>
							<Group position="center" className="logInpMargin">
								<Link
									style={{
										width: "100%",
										border: "1px solid #14B8E1",
										background: " none",
										color: "white",
										textDecoration: "none",
										textAlign: "center",
										padding: "5px",
										borderRadius: "5px",
									}}
									to="/signup"
								>
									Sign Up Now
								</Link>
							</Group>
						</form>
					</Box>
				</Container>
			</div>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
		</AppShell>
	);
}
export default Login;
